/**
 * NextGen Components
 *
 * A collection of modern, feature-rich UI components for building
 * consistent and accessible interfaces.
 */

// Table & List
export { default as DataTable } from './DataTable';
export { default as List, ListItem, ListItemSkeleton } from './List';

// Calendar
export { default as Calendar, CalendarDay, DEFAULT_STATUS_COLORS as CALENDAR_STATUS_COLORS } from './Calendar';

// Badges
export {
	default as Badge,
	StatusBadge,
	PriorityBadge,
	DueDateBadge,
	getDueDateStatus,
} from './Badge';

// Form Controls
export { default as FilterDropdown } from './FilterDropdown';
export { default as MultiSelectPopover } from './MultiSelectPopover';
export { default as InlineSelect } from './InlineSelect';
export { default as DatePicker, DateRangePicker } from './DatePicker';
export { default as DateTimePicker } from './DateTimePicker';
export { default as UserSelect } from './UserSelect';

// Typography
export { default as TextStack } from './TextStack';

// Feedback
export { default as ProgressBar, ProgressBarGroup } from './ProgressBar';

// Modal
export { default as StackableModal } from './StackableModal';

// Navigation
export { default as Tabs } from './Tabs';

// Asset Display
export { default as AssetSelectorBeta } from './AssetSelectorBeta';
export { default as SelectedAssetsList } from './SelectedAssetsList';
export { default as AssetInfoCard } from './AssetInfoCard';

// Vendor Display
export { default as VendorSelectorBeta } from './VendorSelectorBeta';

// Task/Checklist
export { default as TaskList, TaskItem, AddTaskInput } from './TaskList';

// Attachments
export {
	default as AttachmentList,
	AttachmentItem,
	AttachmentBadge,
} from './AttachmentList';

// Image Gallery
export {
	default as ImageGallery,
	ImageThumbnail,
	isImage,
	getNonImageAttachments,
	getImageAttachments,
} from './ImageGallery';

// E-Signature
export { default as ESignatureCard, ESignatureList } from './ESignatureCard';

// File Upload
export { default as FileUpload } from './FileUpload';
export { default as AddAttachmentButton } from './AddAttachmentButton';
